import { Matrix4, type BufferGeometry } from 'three'
import { PART, type MeshRecipe } from './meshes.js'

/** Rest-pose geometry for icons and silhouette capture, including squad members. */
export function previewGeometries(recipe: MeshRecipe): BufferGeometry[] {
  const geometries: BufferGeometry[] = []
  const transform = new Matrix4()
  for (const offset of recipe.copies ?? [[0, 0, 0]]) {
    transform.makeTranslation(offset[0], offset[1], offset[2])
    for (const part of recipe.parts) {
      if (part.kind === PART.Works || (part.kind >= PART.MountGun && part.kind <= PART.MountCrane)) continue
      geometries.push(part.geometry.clone().applyMatrix4(transform))
    }
  }
  return geometries
}
